{
    "copy_successful": "In Zwischenablage kopiert.",
    "copy_failed": "Kopieren in die Zwischenablage fehlgeschlagen."
}
